// // src/components/CartBadge.js
// import React from "react";
// import { Link } from "react-router-dom";
// import { getCart } from "../cart/cart-utils";
// import "./CartBadge.css";
// import { FiShoppingCart } from "react-icons/fi";
// import { ReactComponent as CartIcon } from "../assets/icons/carrinho.svg";
// export default function CartBadge({ className = "" }) {
//   const items = getCart();
//   const totalQty = items.reduce((sum, it) => sum + (Number(it?.qty) || 0), 0);

//   return (
//     <Link
//       to="/carrinho"
//       className={`btn btn-outline-light btn-sm rounded-pill d-flex align-items-center gap-2 position-relative ${className}`}
//       title="Abrir carrinho"
//       aria-label={`Abrir carrinho com ${totalQty} item${totalQty === 1 ? "" : "s"}`}
//     >
//       {/* <span role="img" aria-hidden>🛒</span> */}

//       {/* <FiShoppingCart aria-hidden="true" className="cart-icon" /> */}
//       <span class="cart-emoji" aria-hidden="true">🛒</span>
//       <span class="cart-icon" aria-hidden="true">
//         <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
//           <path d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm10 0a2 2 0 1 0 .001 3.999A2 2 0 0 0 17 18ZM6.2 5l.5 2H21a1 1 0 0 1 .96 1.28l-2 7A1 1 0 0 1 19 16H8a1 1 0 0 1-.96-.72L4.28 3H2a1 1 0 1 1 0-2h3a1 1 0 0 1 .96.72L6.2 5Z" />
//         </svg>

       

//       </span>
//       <span>Carrinho</span>

//       {totalQty > 0 && (
//         <span
//           className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
//           style={{ fontSize: "0.65rem", minWidth: "1.25rem" }}
//         >
//           {totalQty}
//           <span className="visually-hidden"> itens no carrinho</span>
//         </span>
//       )}
//     </Link>
//   );
// }
// src/components/CartBadge.js
import React from "react";
import { Link } from "react-router-dom";
import { getCart } from "../cart/cart-utils";
import "./CartBadge.css";

// IMPORTA seu SVG como componente
import { ReactComponent as CartIcon } from "../assets/icons/carrinho.svg";

export default function CartBadge({ className = "" }) {
  const items = getCart();
  const totalQty = items.reduce((sum, it) => sum + (Number(it?.qty) || 0), 0);

  return (
   // src/components/CartBadge.js
<Link
  to="/carrinho"
  className={`btn btn-outline-light btn-sm rounded-pill d-flex align-items-center gap-2 position-relative btn-cart ${className}`}
  title="Abrir carrinho"
  aria-label={`Abrir carrinho com ${totalQty} item${totalQty === 1 ? "" : "s"}`}
>
  <CartIcon className="cart-icon" aria-hidden="true" />
  <span>Carrinho</span>
  {totalQty > 0 && (
    <span
      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
      style={{ fontSize: "0.65rem", minWidth: "1.25rem" }}
    >
      {totalQty}
      {/* <span className="visualmente-hidden"> itens no carrinho</span> */}
    </span>
  )}
</Link>

  );
}
